<template>
  <div v-if="showTranscript">
    <div class="panel is-primary">
      <div class="panel-block">
        <ul class="menu-list">
          <template v-for="d in transcript">
            <li :key="d.day + Math.random()">
              <span class="day">[{{ d.day }}]</span>
              <span class="num dead">{{ Number(d.total.deaths).toLocaleString() }}</span>
              <span class="num recovered">{{ Number(d.total.recovered).toLocaleString() }}</span>
              <span class="num neutral">{{ Number(d.total.confirmed).toLocaleString() }}</span>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Transcript',
  data() {
    return {
      transcript: [],
      maxEntries: 15,
    };
  },
  computed: {
    playing() {
      return this.$store.state.playing;
    },
    currentDataIndex() {
      return this.$store.state.currentDataIndex;
    },
    country() {
      return this.$store.state.globalData;
    },
    dataAvailable() {
      return this.country.length > 0 && this.currentDataIndex !== undefined;
    },
    showTranscript() {
      return this.$store.state.showTranscript;
    },
  },
  watch: {
    currentDataIndex(newIdx) {
      if (this.dataAvailable) {
        const currentTranscript = this.transcript;
        const newCountryEntry = { ...this.country[newIdx] };
        const toModify = newCountryEntry.day;
        newCountryEntry.day = `${toModify.split(' ')[1]} ${toModify.split(' ')[2]}`;
        currentTranscript.push(newCountryEntry);
        if (currentTranscript.length > this.maxEntries) {
          currentTranscript.shift();
        }
        this.transcript = currentTranscript;
      }
    },
  },
};
</script>

<style scoped>
.panel-heading {
  letter-spacing: 0.1em;
  text-transform: uppercase;
  text-align: center;
}

.panel-block {
  color: gainsboro;
  font-size: 0.8rem;
  font-variant-numeric: tabular-nums;
  font-family: monospace;
  border: 0;
}

.menu-list {
  line-height: 2;
}

.menu-list li {
  justify-content: space-between;
  display: flex;
}

.day {
  width: 80px;
}

.dead {
  color: #fa5b5a;
  width: 70px;
  text-align: right;
}

.neutral {
  color: #23a3c0;
  width: 70px;
  text-align: right;
}

.recovered {
  color: #8cff57;
  width: 70px;
  text-align: right;
}

.num {
  text-align: right;
}

article {
  float: right;
  text-align: right;
}

.panel.is-primary {
  /*float: right;*/
}
.panel-block {
  text-align: right;
  float: right;
}

.panel {
  min-height: 385px;
  max-height: 385px;
}
</style>
